import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export function confirmAction({
    title = 'Are you sure?',
    text,
    confirmButtonText = 'Yes, proceed!',
}) {
    return MySwal.fire({
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1F2937',
        cancelButtonColor: '#CA1A41',
        confirmButtonText,
    }).then(result => result.isConfirmed);
}

export function confirmDelete(text) {
    return confirmAction({
        text,
        confirmButtonText: 'Yes, delete it!',
    });
}
